import TableTemplate from "../TableTemplate/tableTemplate";
import {
  IPortfolioSearchParams,
  IPortfolioTableReport,
} from "../../Interfaces/portfolio";
import { CommonTableUI } from "../TableTemplate/common";
import { getPortfolioTable } from "../../Requests/portfolioRequests";
// Local Component
import { Additional } from "./Additional";

interface IProps {
  searchParams: IPortfolioSearchParams;
  refreshFlag: boolean;
  onFetchComplete: () => void;
}

const PortfoTable = ({
  searchParams,
  refreshFlag,
  onFetchComplete,
}: IProps) => {
  return (
    <TableTemplate<IPortfolioSearchParams, IPortfolioTableReport>
      getDataTable={getPortfolioTable}
      TableUI={({ reports, onAction, setSortingType, sortingType }) => (
        <CommonTableUI
          reports={reports}
          refreshFlag={refreshFlag}
          sortingType={sortingType}
          setSortingType={setSortingType}
          tableBoxClassName="!mx-0"
          onAction={onAction}
          AdditionalBody={Additional}
        />
      )}
      withSort
      searchParameters={searchParams}
      onFetchComplete={onFetchComplete}
    />
  );
};

export default PortfoTable;
